import Vue from 'vue'
export default () => {
  const init = {
    appliedConfig: [],
    PDFJSObject: null,
    base64: "",
    cutPdf: {
      isFocused: false,
      isVisible: false,
      isChanged: false,
      preset: {
        applied: false,
        coordinates: {},
        points: [],
        show: false,
      }
    },
    employee: {
      isFocused: false,
      isVisible: false,
      preset: {
        position: "",
        paper: "A4",
        orientation: "P",
        page: 1,
        show: false,
        default: false,
        x: 0,
        y: 0
      }
    },
    employer: {
      isFocused: false,
      isVisible: false,
      preset: {
        position: "",
        paper: "A4",
        orientation: "P",
        page: 1,
        show: false,
        x: 0,
        y: 0
      }
    },
    file: null,
    orientation: "P",
    page: 1,
    paper: "A4",
    rotation: 0,
    rotationPending: false,
    rotationApplied: false,
    size: {},
    thumbnails: {
      employee: {},
      employer: {},
      thumbnail: {}
    }
  }
  const state = Vue.observable({
    config: { ...init }
  })
  const setModalState = (newConfig) => {
    state.config = { ...state.config, ...newConfig }
  }
  const setModalStateProperty = (newConfig, parent, prop) => {
    if (state.config[parent] && prop) {
      state.config[parent][prop] = { ...state.config[parent][prop], ...newConfig }
      return
    }
    state.config[parent] = { ...state.config[parent], ...newConfig }
  }
  const resetModalState = () => state.config = init
  return {
    state,
    resetModalState,
    setModalState,
    setModalStateProperty
  }
}